import { PhoneInput, useInputValidation } from '@landsbankinn/ui';
import React from 'react';

interface IProps {
  phoneNumber: string;
  setPhoneNumber: (number: string) => void;
  label?: string;
}

export function PhoneNumber({ phoneNumber, setPhoneNumber, label }: IProps) {
  const [ref, isValid, message] = useInputValidation(phoneNumber, [
    {
      validation: (v) => {
        return v !== undefined && v.replaceAll('-', '').length === 7;
      },
      message: 'Símanúmer er ekki á réttu formi',
    },
  ]);
  return (
    <PhoneInput
      inputRef={ref}
      isValid={isValid}
      errorMessage={message}
      label={label ?? 'Símanúmer'}
      value={phoneNumber}
      onValueChange={(number) => setPhoneNumber(number.value)}
      variant="noBorder"
      labelVariant="aboveInput"
    />
  );
}
